module.exports = fox._r("images/pirates/gift-121.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/pirates/gift-121.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/pirates/gift-121.png
// module id = 322
// module chunks = 4